import { useCallback } from "react";

import type { AsyncOption } from "@/components/async-combobox";
import { searchPurchaseRequestsPath } from "@/routes";

interface PurchaseRequestSearchResult {
  id: number;
  label: string;
  request_number: string;
  status: string;
  sector_name?: string;
}

export function usePurchaseRequestSearch(_supplierId?: number) {
  return useCallback(
    async (term: string): Promise<AsyncOption[]> => {
      // NOTE: Intentionally using global search to keep results available
      // even when supplier linkage is incomplete. Reintroduce supplier-aware
      // narrowing only when the dataset guarantees sufficient linkage depth.
      const params = new URLSearchParams({ global: "1" });
      if (term) params.set("term", term);

      const url = `${searchPurchaseRequestsPath()}?${params.toString()}`;
      const response = await fetch(url);
      if (!response.ok) return [];

      const payload = (await response.json()) as PurchaseRequestSearchResult[];
      return payload.map((item) => {
        const sector = item.sector_name ? ` - ${item.sector_name}` : "";
        const fullLabel = `${item.label}${sector}`;
        return {
          value: item.id,
          label: fullLabel.length > 60 ? `${fullLabel.slice(0, 60)}…` : fullLabel,
          fullLabel,
        } satisfies AsyncOption;
      });
    },
    [],
  );
}
